export const initialize = {
    authorization: localStorage.getItem('authorizationToken'),
    config: null
}

//Reducer Creator Helper
const createReducer = (initialize, handlers) => {
    return function reducerHelper(state = initialize, action) {
        if (handlers.hasOwnProperty(action.type)) {
            return handlers[action.type](state, action)
        } else {
            return state
        }
    }
}

//Action constants
const Actions = {
    STORE_AUTHORIZATION: 'STORE_AUTHORIZATION',
    STORE_CONFIG: 'STORE_CONFIG'
}

//Action Creators
export const storeConfig = (config) => ({
    type: Actions.STORE_CONFIG,
    config
});

//Actual Reducer
const Reducer = createReducer(initialize, {

        [Actions.STORE_AUTHORIZATION]: (state, action) => {
            state = {
                ...state,
                authorization: action.token
            }
            return state;
        },

        [Actions.STORE_CONFIG]: (state, action) => {
            return {
                ...state,
                    config: action.config
            };
        }
    }
);
export default Reducer;
